/* istanbul ignore file */
import React from 'react';

export default function ProductImage({ src, alt, onImageError }) {
    return (
        <img
            src={src != null ? src : '/noImage.jpg'}
            alt={alt}
            onError={e => {
                e.target.onerror = null;
                e.target.src = '/noImage.jpg';
                onImageError && onImageError();
            }}
        />
    );
}
